<template>
  <router-link v-if="routerLink" :to="url" class="btn-image shadow">
    <img :src="image" />
    <span class="btn-image-title">
      {{ title }}
      <md-icon style="height: auto;">{{ icon }}</md-icon>
    </span>
  </router-link>
  <a v-else :href="url" target="_blank" class="btn-image shadow">
    <img :src="image" />
    <span class="btn-image-title">
      {{ title }}
      <md-icon style="height: auto;">{{ icon }}</md-icon>
    </span>
  </a>
</template>
<script>
export default {
  name: "ButtonImage",
  props: {
    title: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "arrow_forward"
    },
    url: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    routerLink: {
      type: Boolean,
      default: true
    }
  }
};
</script>
